let installed = false

export function installCanvasReadbackOptimization() {
  if (installed || typeof window === 'undefined') return
  installed = true

  const nativeGetContext = HTMLCanvasElement.prototype.getContext
  HTMLCanvasElement.prototype.getContext = function (contextId: string, options?: any) {
    if (contextId !== '2d') return nativeGetContext.call(this, contextId, options)
    return nativeGetContext.call(this, contextId, { ...(options || {}), willReadFrequently: true })
  }
}
